import { DialogRef, DIALOG_DATA } from '@angular/cdk/dialog';
import { Component, Inject } from '@angular/core';


export interface ImageDialogData {
  url: string;
  name: string;
}

@Component({
    selector: 'canvas-admin-image-viewer',
    templateUrl: './image-viewer.component.html',
    styleUrls: ['./image-viewer.component.scss'],
    standalone: false
})
export class ImageViewerComponent {
  constructor(
    @Inject(DIALOG_DATA) public data: ImageDialogData,
    public dialogRef: DialogRef
  ) {}
}
